<template>
	<div class="c-mobile-nav__item">
		<a :href="`#${anchor}`" class="c-mobile-nav__link">
			<span aria-hidden="true" class="c-icon c-icon--m c-mobile-nav__icon">
				<svg><use :xlink:href="`#icon-${icon}`"></use></svg>
			</span>
			<slot />
		</a>
	</div>
</template>

<script>
export default {
	name: "VMobileNavItem",
	props: {
		icon: {
			type: String
		},
		anchor: {
			type: String,
			required: true
		}
	}
};
</script>
